<form
  [formGroup]="form"
  (click)="$event.stopPropagation()"
  (keydown.tab)="$event.stopPropagation()"
  (keydown.shift)="$event.stopPropagation()"
  data-cy="schedule-reminder-form"
  class="reminder-form tw-pt-3">
  <formly-form
    [form]="form"
    [fields]="fields"
    [model]="model"
    [options]="options"
    (modelChange)="change($event)">
  </formly-form>
  <div class="reminder-form-btn-row">
    <button
      mat-flat-button
      data-cy="cancel-reminder"
      class="cancel-btn"
      (click)="closeNewReminder();">
      Cancel
    </button>
    <button
      data-cy="schedule-reminder-submit-btn"
      mat-flat-button
      color="primary"
      (click)="onSubmit();"
      [disabled]="!form.valid">
      Submit
    </button>
  </div>
</form>
